import api from './api';

const donationService = {
  // Initialize Donation
  initializeDonation: async (data) => {
    const response = await api.post('/donation/initialize', data);
    return response.data;
  },

  // Verify Payment
  verifyPayment: async (data) => {
    const response = await api.post('/donation/verify', data);
    return response.data;
  },

  // Get Donation Receipt
  getDonationReceipt: async (id) => {
    const response = await api.get(`/donation/receipt/${id}`);
    return response.data;
  },

  // Get My Donations
  getMyDonations: async (params) => {
    const response = await api.get('/donation/my', { params });
    return response.data;
  },

  // Get Public Stats
  getPublicStats: async () => {
    const response = await api.get('/donation/stats');
    return response.data;
  },
};

export default donationService;
